// Real location-data helpers for the service-worker registration form.
//
// Backend reality (read-only — verified in Tasmeh-backend, see
// services/mechanic.service.js and routes/mechanic.routes.js): there is NO
// Neshan/maps endpoint, no map API key, and no lat/lng columns — location is
// only the free-text `address` field. So the short human-readable summary
// shown for a picked map point comes from the keyless OpenStreetMap
// Nominatim reverse service (no key, nothing secret to expose). Every string
// returned here is built ONLY from that real response — nothing is invented
// or hardcoded. Failures resolve to "" and callers fall back to a neutral
// "selected" status, never to fake address data.
export async function fetchReverseGeocode(lat, lng) {
  try {
    const url =
      `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}` +
      `&lon=${lng}&accept-language=fa`;
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) return null;
    const data = await res.json();
    return data && typeof data === "object" ? data : null;
  } catch {
    return null;
  }
}

// Build a short summary (e.g. "خیابان ولیعصر، تهران") from a real
// Nominatim reverse response. Returns "" when the response carries no
// usable address parts — callers must treat "" as "unknown", not invent one.
export function shortenLocation(data) {
  if (!data || typeof data !== "object") return "";
  const a = data.address && typeof data.address === "object" ? data.address : {};
  const parts = [];
  const push = (value) => {
    if (typeof value === "string") {
      const v = value.trim();
      if (v && !parts.includes(v)) parts.push(v);
    }
  };
  push(a.road || a.street || a.pedestrian || a.footway || a.cycleway || a.path);
  push(
    a.neighbourhood ||
      a.suburb ||
      a.quarter ||
      a.residential ||
      a.village ||
      a.hamlet ||
      a.locality
  );
  push(a.city || a.town || a.county || a.state);
  if (parts.length > 0) return parts.slice(0, 3).join("، ");
  if (typeof data.display_name === "string") {
    const comps = data.display_name
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
    if (comps.length > 0) return comps.slice(0, 2).join("، ");
  }
  return "";
}
